// extracted by mini-css-extract-plugin
export var active = "popup-module--active--33cFx";
export var popup = "popup-module--popup--oILQN";